/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import React from 'react';

/**
 * Custom video file icon.
 * @export
 */

export const CUSTOM_FILE_VIDEO_ICON = (
  <svg fill="none" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
    <rect fill="#E0D9EF" height="15" rx="1.5" stroke="#AC98D5" width="21" x="1.5" y="4.5" />
    <path
      d="M9.5 15.2516V8.74842C9.5 8.36171 9.92019 8.12138 10.2535 8.31745L15.7812 11.569C16.1099 11.7624 16.1099 12.2376 15.7812 12.431L10.2535 15.6826C9.92019 15.8786 9.5 15.6383 9.5 15.2516Z"
      fill="#AC98D5"
      stroke="#6B47B4"
      strokeLinecap="round"
    />
  </svg>
);
